import * as React from 'react';
// import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { KeyValueComponent } from './Components/KeyValueComponent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '& .MuiDialog-paper': {
    width: '90%',
    maxWidth: '700px',
    height: 'auto'
  }
}));

export default function OptionModal(props) {

  return (
    <React.Fragment>
      <BootstrapDialog
        // onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        fullWidth={true}
        maxWidth="100%"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" variant='h3'>{props.selected}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ marginInline: 2 }}>
          <KeyValueComponent selected={props.selected} data={props.data} userId={props.userId} userData={props.userData} />
        </DialogContent>
        <DialogActions>
          <></>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
